import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Interruptor de FOTOS DE PRODUCTO por bot (13-oct-2026).
 *
 * Escribe `fotosDeProducto: { activado }` en `bots/{botId}/integrations/config` por el
 * `onUpdate` del panel (el mismo camino que el seguimiento automático), y es exactamente lo
 * que lee el backend (`functions/bot/utils/fotosDeProducto.js` → `fotosActivadas`, que sólo
 * acepta `activado === true`). Apagado por defecto: sin documento, sin campo o con cualquier
 * otro valor, el bot no manda fotos.
 */
export function estaActivado(config) {
  return config?.fotosDeProducto?.activado === true;
}

export default function FotosDeProductoConfig({ config, onUpdate }) {
  const { t } = useTranslation('bots');
  const [activado, setActivado] = useState(estaActivado(config));
  const [saving, setSaving] = useState(false);

  useEffect(() => { setActivado(estaActivado(config)); }, [config?.fotosDeProducto?.activado]);

  // `onUpdate` es el `handleUpdate` del panel: devuelve true/false y él da el aviso del
  // error. Aquí sólo se vuelve atrás; un segundo aviso sería el mismo error dos veces.
  const cambiar = async (valor) => {
    const anterior = activado;
    setActivado(valor);
    setSaving(true);
    try {
      if ((await onUpdate({ fotosDeProducto: { activado: valor } })) !== true) setActivado(anterior);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="fotos-de-producto" style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '1.5rem', marginTop: '1rem' }}>
      <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>{t('integrations.fotosDeProducto.title')}</h3>
      <p style={{ color: '#718096', fontSize: '0.875rem', margin: '0 0 1rem 0' }}>{t('integrations.fotosDeProducto.desc')}</p>
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: saving ? 'wait' : 'pointer' }}>
        <input
          type="checkbox"
          role="switch"
          aria-checked={activado}
          checked={activado}
          disabled={saving}
          onChange={(e) => cambiar(e.target.checked)}
        />
        <span>{t('integrations.fotosDeProducto.enable')}</span>
      </label>
      <p style={{ color: '#a0aec0', fontSize: '0.8rem', margin: '0.5rem 0 0 0' }}>{t('integrations.fotosDeProducto.enableHint')}</p>
    </div>
  );
}
